import { render, staticRenderFns } from "./materialCostDetails.vue?vue&type=template&id=6ca09100&scoped=true"
import script from "./materialCostDetails.vue?vue&type=script&lang=js"
export * from "./materialCostDetails.vue?vue&type=script&lang=js"
import style0 from "./materialCostDetails.vue?vue&type=style&index=0&id=6ca09100&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca09100",
  null
  
)

export default component.exports